<!--
 * @Description: 通用列表组件，需要listData，loading，
 * @Date: 2020-09-25 18:02:30
-->
<template>
  <div>
    <slot v-if="$attrs.listData.length" :data="$attrs.listData"></slot>
    <div
      :class="['missBox',defaultMid ? 'abs-mid' : '']"
      v-else-if="!$attrs.listData.length && !$attrs.loading"
    >
      <img :src="defaultPic" />
      <p>{{defaultText}}</p>
    </div>
    <van-loading style="text-align:center;margin-top: 1rem" size="24px" v-if="$attrs.loading">加载中...</van-loading>
  </div>
</template>
<script>
export default {
  props: {
    defaultText: {
      type: String,
      default: '抱歉，暂无内容呦~'
    },
    defaultMid: {
      type: Boolean,
      default: false
    },
    defaultPic:{
      type: String,
      default: require('@/static/img/missing.png')
    }
  }
};
</script>